<div class="collection-container">
    <ngxh6-form-embed
        class="flex-grow-1 app-community-staff-select-form"
        [model]="model"
        (submitted)="onSubmit($event)"
        [formName]="'known_client'"
        [component]="knownClientFormComponent"
    ></ngxh6-form-embed>

    <ng-container>
        @if (inputValue) {
            {{ initialiseFrequentFlyers() }}
            <hr />
            @for (item of Object.values(inputValue); track item; let i = $index) {
                <div class="known-client">
                    <div class="d-flex align-items-center">
                        <ngxh6-offline-indicator [model]="item" class="me-2"></ngxh6-offline-indicator>
                        <ngxh6-usericon [user]="item" class="me-3"></ngxh6-usericon>
                        <p class="mb-0">
                            @if (userService.isGranted('ROLE_PATROL_MANAGER')) {
                                <a [routerLink]="'/clients/' + item.contact?.id">
                                    {{ item.contact?.firstName + ' ' + item.contact?.lastName }}
                                    @if (item.archived) {
                                        (archived)
                                    }
                                </a>
                            }
                            @if (!userService.isGranted('ROLE_PATROL_MANAGER')) {
                                @if (frequentFlyers[item.contact?.id] && frequentFlyers[item.contact?.id] > 0) {
                                    <span [ngClass]="getFrequentFlyerClass(frequentFlyers[item.contact?.id]) + ' mx-2 rounded-1 text-white p-2'">
                                        <i class="fass fa-plane pe-1"></i>x {{ frequentFlyers[item.contact?.id] }}
                                    </span>
                                }
                                {{ item.contact?.firstName + ' ' + item.contact?.lastName }}
                                @if (item.contact?.archived) {
                                    (archived)
                                }
                            }
                            @if (item?.__offline_create__) {
                                <span class="small text-muted">created offline</span>
                            }
                        </p>
                        <div class="ms-auto">
                            @if (item.requiresReferral) {
                                <span [ngbTooltip]="'Referral Required'"> <i class="fass fa-xl fa-fw fa-hand pe-1 me-4 align-middle"></i></span>
                            }
                            <button type="button" class="btn btn-danger collection-remove" (click)="delete(item.id, i)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <hr />
            }
        }
        @if (!inputValue) {
            <small class="my-4 text-muted">There are no known clients for this engagement.</small>
        }
    </ng-container>
</div>
